RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    graph.PieChart = graph.Block.extend({
        className: 'pie-chart',
        margin: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },

        renderData: function (svg, data) {
            const me = this;
            const concept = me.getOption('concept');

            const radius = _.min([me.dimensions.height, me.dimensions.width]) / 2;
            const arc = d3.svg.arc()
                .outerRadius(radius - 10)
                .innerRadius(0);

            const pie = d3.layout.pie()
                .sort(null)
                .value(_.last);

            const chart = svg.select('.grid')
                .attr('transform', `translate(${me.dimensions.width / 2},${me.dimensions.height / 2})`);

            const slice = chart.selectAll('.slice')
                .data(pie(data));

            slice
                .enter().append('g')
                .append('path');

            slice
                .attr('fill', getFill)
                .attr('class', getClassName);

            function getFill(d, i) {
                if (_.isArray(concept)) {
                    return concept[i].getColor();
                }

                return concept.color(data[i]);
            }

            function getClassName(d, i) {
                if (_.isArray(concept)) {
                    return `slice ${concept[i].getClassName()}`;
                }
                return `slice ${concept.getClassName(data[i])}`;
            }

            slice.select('path')
                .attr('d', arc);

            slice.exit().remove();
        }
    });

    graph.PieChart.reloadable = true;
}, window.d3);
